<template>
  <countdown :to="props.to" @ended="emit('ended')" v-slot="{ countdown }">
    <slot name="default" :countdown="countdown">
      <!--
        Mobile: a single-line badge (label · value) straddling the panel's top
        edge, with abbreviated units ("2 hr 25 min"). Desktop: two lines, full
        words, right-aligned. The aria-label/title carries the plain-text version.
      -->
      <scoreboard-badge v-bind="$attrs" wide="md">
        <template #label>
        <slot name="label">
          <p
            class="flex items-center gap-x-1.5 md:justify-start md:pb-1 text-sm md:text-base leading-none"
          >
            <i class="fa-solid fa-clock text-sm md:text-lg" aria-hidden="true" />
            <span>Time Remaining</span>
          </p>
        </slot>
        </template>

        <fade-transition>
          <p
            v-if="!countdown.ended"
            key="running"
            role="timer"
            :aria-label="countdown.text"
            :title="countdown.text"
            class="flex items-baseline gap-x-2 md:justify-end leading-none font-14seg tracking-widest text-lg md:text-2xl"
          >
            <span
              v-for="segment in countdown.segments"
              :key="segment.unit"
              class="whitespace-nowrap"
            >
              <fade-transition>
                <span :key="segment.value">{{ segment.value }}</span>
              </fade-transition>
              <span class="font-digi tracking-normal text-[0.55em] pl-1">
                <span class="md:hidden">{{ segment.short }}</span>
                <span class="hidden md:inline">{{ segment.label }}</span>
              </span>
            </span>
          </p>
          <p v-else key="ended" class="font-14seg text-lg md:text-2xl leading-none">
            Ended
          </p>
        </fade-transition>
      </scoreboard-badge>
    </slot>
  </countdown>
</template>
<script setup lang="ts">
import Countdown from "@/components/Headless/Countdown.vue";
import ScoreboardBadge from "@/components/ScoreboardBadge.vue";
import { DateTime } from "ts-luxon";
const props = defineProps<{
  to: DateTime;
}>();

const emit = defineEmits(["ended"]);
</script>
